import React from 'react';
import {
  formatPrice,
  calculateDaysDiff,
} from '../../utilities/FormatFunctions';

export default function RealEstatesItems({
  index,
  realEstate,
  handleDeleteClick,
  handleEditClick,
}) {
  return (
    <>
      <tbody className="bg-white divide-y divide-gray-200">
        <tr>
          <td className="px-4 py-4 text-sm text-gray-500 whitespace-nowrap">
            <div className="flex items-center gap-x-3">
              <div className="flex items-center gap-x-2">
                <div>
                  <h2 className="text-gray-500">{realEstate.name}</h2>
                </div>
              </div>
            </div>
          </td>
          <td className="px-4 py-4 text-sm text-gray-500 whitespace-normal w-80 text-justify">
            <div className="w-60">
              <div className="flex justify-center overflow-hidden">
                {realEstate.description}
              </div>
            </div>
          </td>
          <td className="px-4 py-4 text-sm text-gray-500 whitespace-nowrap text-center">
            <span className="inline-flex items-baseline">
              ${formatPrice(realEstate.price)}
              {realEstate.businessType === 'Arriendo' ? (
                <span className="text-[10px] leading-none">/mes</span>
              ) : null}
            </span>
          </td>
          <td className="px-4 py-4 text-sm text-gray-500 whitespace-nowrap text-center">
            {realEstate.city}
          </td>
          <td className="px-4 py-4 text-sm text-gray-500 whitespace-nowrap text-center">
            {realEstate.sector}
          </td>
          <td className="px-4 py-4 text-sm text-gray-500 whitespace-nowrap text-center">
            {realEstate.area} m²
          </td>
          <td className="px-4 py-4 text-sm text-gray-500 whitespace-nowrap text-center">
            {realEstate.floor}
          </td>
          <td className="px-4 py-4 text-sm text-gray-500 whitespace-nowrap text-center">
            {realEstate.bedrooms}
          </td>
          <td className="px-4 py-4 text-sm text-gray-500 whitespace-nowrap text-center">
            {realEstate.bathrooms}
          </td>
          <td className="px-4 py-4 text-sm text-gray-500 whitespace-nowrap text-center">
            {realEstate.kitchens}
          </td>
          <td className="px-4 py-4 text-sm text-gray-500 whitespace-nowrap text-center">
            {realEstate.balcony ? 'Si' : 'No'}
          </td>
          <td className="px-4 py-4 text-sm text-gray-500 whitespace-nowrap text-center">
            {realEstate.yards}
          </td>
          <td className="px-4 py-4 text-sm text-gray-500 whitespace-nowrap text-center">
            {realEstate.garage ? 'Si' : 'No'}
          </td>
          <td className="px-4 py-4 text-sm text-gray-500 whitespace-nowrap text-center">
            {realEstate.state}
          </td>
          <td className="px-4 py-4 text-sm whitespace-nowrap">
            <div className="flex items-center gap-x-2">
              {calculateDaysDiff(realEstate.createdAt) <= 15 && (
                <span className="bg-amber-300 font-heading border border-gray-700 tracking-wide text-black font-medium shadow-custom-left text-xs px-3 py-1 rounded-full">
                  ¡Nuevo!
                </span>
              )}
              <span
                className={`border font-heading border-gray-700 tracking-wide text-black font-medium shadow-custom-left text-xs px-3 py-1 rounded-full
                  ${
                    realEstate.businessType !== 'Venta'
                      ? 'bg-indigo-300'
                      : 'bg-emerald-300'
                  }`}
              >
                {realEstate.businessType !== 'Venta'
                  ? 'En arriendo'
                  : 'En venta'}
              </span>
            </div>
          </td>
          <td className="px-4 py-4 text-sm whitespace-nowrap">
            <div className="flex items-center gap-x-4">
              <button
                onClick={() => handleEditClick(realEstate)}
                className="text-gray-500 transition-colors duration-200 hover:text-customBlue focus:outline-none"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth="1.5"
                  stroke="currentColor"
                  className="w-5 h-5"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10"
                  />
                </svg>
              </button>
              <button
                onClick={() => handleDeleteClick(realEstate)}
                className="text-gray-500 transition-colors duration-200 hover:text-red-500 focus:outline-none"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth="1.5"
                  stroke="currentColor"
                  className="w-5 h-5"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"
                  />
                </svg>
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </>
  );
}
